import useShipmentFetch from "./useShipmentFetch"

export default () => {
  const { shipmentFetch, isLoading } = useShipmentFetch()

  return {
    /** { email, orderId, notificationType } */
    sendOrderNotification: async (params) => {
      const responseJson = await shipmentFetch(`shipping/order/notification`, { 
        method: 'POST',
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(params),
        nosupress: true
      })
      if (!responseJson.status) throw new Error(responseJson.message)
      return responseJson
    },
    sendOrderIsLoading: isLoading,
    
    NotificationTypes: {
      'OrderCreated': { id: 'OrderCreated', name: 'Order Created', emailTemplateId: 'OrderCreated' },
      'OrderDelivered': { id: 'OrderDelivered', name: 'Order Delivered', emailTemplateId: 'OrderDelivered' }
    }
  }
}